import { flexRender } from '@tanstack/react-table'
import PropTypes from 'prop-types'
import { useVirtual } from 'react-virtual'

import { classNames } from '../../helpers'

// Mit edgeGutter tragen erste und letzte sichtbare Spalte den Seitenrand statt
// des Containers. So laufen Linien und Hover bis an die Kante, der Inhalt steht
// trotzdem bündig mit Überschrift und Filterleiste. Gilt für Header und Zellen.
export const getEdgeGutterClass = (items, index) => {
  const padded = items
    .map(({ column }, i) => (column.columnDef.invisible ? null : i))
    .filter((i) => i !== null)

  return classNames(
    index === padded[0] && 'md:pl-6 lg:pl-8',
    index === padded[padded.length - 1] && 'md:pr-6 lg:pr-8'
  )
}

const TableBody = ({
  data,
  disableVirtual,
  disableHover,
  edgeGutter,
  highlightRowIds
}) => {
  const { table, tableContainerRef } = data

  const { rows } = table.getRowModel()

  const { virtualItems: virtualRows, totalSize } = useVirtual({
    parentRef: tableContainerRef,
    size: rows.length,
    overscan: 100
  })

  const paddingTop = virtualRows.length > 0 ? virtualRows?.[0]?.start || 0 : 0
  const paddingBottom =
    virtualRows.length > 0
      ? totalSize - (virtualRows?.[virtualRows.length - 1]?.end || 0)
      : 0

  const tableRows = disableVirtual ? rows : virtualRows

  return (
    <tbody className='divide-y divide-gray-200'>
      {!disableVirtual && paddingTop > 0 && (
        <tr>
          <td style={{ height: `${paddingTop}px` }} />
        </tr>
      )}
      {tableRows.map((tableRow) => {
        const row = disableVirtual ? tableRow : rows[tableRow.index]

        return (
          <tr
            key={row.id}
            className={classNames(
              disableHover ? '' : 'group cursor-pointer hover:bg-gray-50',
              highlightRowIds.includes(row.original?.id) && 'animate-rowflash'
            )}
          >
            {row.getVisibleCells().map((cell, index, cells) => (
              <td
                key={cell.id}
                className={classNames(
                  'whitespace-nowrap',
                  cell.column.columnDef.invisible ? '' : 'px-4 py-4',
                  edgeGutter && getEdgeGutterClass(cells, index)
                )}
                onClick={
                  cell.column.columnDef.onClick
                    ? () => cell.column.columnDef.onClick(cell)
                    : undefined
                }
              >
                {flexRender(cell.column.columnDef.cell, cell.getContext())}
              </td>
            ))}
          </tr>
        )
      })}
      {!disableVirtual && paddingBottom > 0 && (
        <tr>
          <td style={{ height: `${paddingBottom}px` }} />
        </tr>
      )}
    </tbody>
  )
}

TableBody.propTypes = {
  data: PropTypes.object.isRequired,
  disableHover: PropTypes.bool,
  disableVirtual: PropTypes.bool,
  edgeGutter: PropTypes.bool,
  highlightRowIds: PropTypes.arrayOf(PropTypes.string)
}

TableBody.defaultProps = {
  disableHover: false,
  disableVirtual: false,
  edgeGutter: false,
  highlightRowIds: []
}

export default TableBody
